import React from 'react';

export default function IconFR() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 21">
            <path
                fill="#41479B"
                d="M10.667 20.655H.552A.543.543 0 0 1 0 20.12V.88C0 .584.247.344.552.344h10.115v20.31Z"
            />
            <path fill="#F5F5F5" d="M21.334.345H10.667v20.31h10.667V.345Z" />
            <path
                fill="#FF4B55"
                d="M31.449 20.655H21.334V.345h10.115c.304 0 .551.239.551.534v19.242a.543.543 0 0 1-.551.534Z"
            />
        </svg>
    );
}
